import { centsToEuros } from '@/constants'
import { CreditCardIcon } from '@heroicons/react/24/solid'
import { PaymentOverviewData, TaxData } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'

type DisplayPaymentOverviewProps = {
	overview: PaymentOverviewData
	tax?: TaxData
}

export function DisplayPaymentDetails({ overview, tax }: DisplayPaymentOverviewProps) {
	const { t } = useTranslation('common')
	const taxPercentage = tax?.taxRate.percentage ?? 0
	const netCredits = Math.round(overview.credits / (1 + taxPercentage / 100))
	return (
		<div className="ml-2">
			<div>
				<span className="font-medium text-gray-700">{t('billing.payment.terms')}</span>
				<span className="ml-2 text-gray-600">
					{t('billing.payment.days', { count: overview.paymentTerms })}
				</span>
			</div>
			<div>
				<span className="font-medium text-gray-700">{t('billing.payment.credits')}</span>
				<span className="ml-2 text-gray-600">
					{taxPercentage > 0 && overview.credits > 0
						? (
							<>
								&euro;{centsToEuros(netCredits).toFixed(2)} {t('billing.payment.net')}{' '}
								/ &euro;{centsToEuros(overview.credits).toFixed(2)} {t('billing.payment.gross')}
							</>
						)
						: <>&euro;{centsToEuros(overview.credits).toFixed(2)}</>}
				</span>
			</div>
			<div>
				<span className="font-medium text-gray-700">{t('billing.payment.card')}</span>
				<span className="ml-2 text-gray-600">
					{overview.card
						? (
							<>
								<CreditCardIcon className="inline mt-0 w-5 h-5 shrink-0" title={overview.card?.brand} />
								<span title={overview.card?.id}>
									&bull; &bull; &bull; &bull; {overview.card?.last4}
								</span>
								({overview.card?.expMonth.toString().padStart(2, '0')}/{overview.card?.expYear})
							</>
						)
						: t('billing.payment.noCard')}
				</span>
			</div>
		</div>
	)
}
